/**
 * Frozen renderer geometry constants for the kiosk wire contract.
 *
 * Binding sources (values must match the kiosks service validation; the
 * contract is frozen for T04 per `services/kiosks/README.md` — "Render
 * document contract" + "Widget catalog" sections — and
 * `packages/types/src/kiosk-widgets.ts`):
 * - 1920×1080 normalized authoring canvas, origin top-left, CSS pixels.
 * - Integer positions; widgets must stay inside the canvas.
 * - `zIndex` bounded to 0–100.
 * - At most 100 widgets per layout; identifiers ≤ 128 chars;
 *   at most 500 IDs per visibility allow/deny list.
 */
export interface RendererGeometry {
  readonly canvas: { readonly width: number; readonly height: number };
  readonly zIndex: { readonly min: number; readonly max: number };
  readonly maxWidgets: number;
  readonly maxIdLength: number;
  readonly maxVisibilityIdsPerRule: number;
}

export const FROZEN_RENDER_GEOMETRY: RendererGeometry = Object.freeze({
  canvas: Object.freeze({ width: 1920, height: 1080 }),
  zIndex: Object.freeze({ min: 0, max: 100 }),
  maxWidgets: 100,
  maxIdLength: 128,
  maxVisibilityIdsPerRule: 500,
});
